(function () {
	'use strict';

	function init() {
		const triggers = document.querySelectorAll('.js-search-trigger');
		const overlay = document.querySelector('.js-body-overlay');
		const activeClass = 'is-active';
		const overflowClass = 'u-overflow-hidden';
		const animationDelay = 200;

		const instances = [];

		triggers.forEach((trigger) => {
			const thisHeader = trigger.closest('.js-site-header');
			const body = thisHeader.querySelector('.js-search-body');
			const close = thisHeader.querySelector('.js-search-close');
			const input = body.querySelector('[type="search"]');

			instances.push({ trigger, body, close, input });
		});

		function closeAllSearch() {
			instances.forEach(({ body }) => {
				body.classList.remove(activeClass);
			});

			document.body.classList.remove(overflowClass);
			overlay.classList.remove(activeClass);
			overlay.setAttribute('aria-hidden', 'true');
		}

		function openSearch(instance) {
			closeAllSearch();

			instance.body.classList.add(activeClass);
			document.body.classList.add(overflowClass);
			overlay.classList.add(activeClass);
			overlay.setAttribute('aria-hidden', 'false');

			setTimeout(() => {
				instance.input.focus();
			}, animationDelay);
		}

		instances.forEach((instance) => {
			instance.trigger.addEventListener('click', (e) => {
				e.stopPropagation();
				openSearch(instance);
			});

			instance.close.addEventListener('click', (e) => {
				e.stopPropagation();
				closeAllSearch();
			});
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				closeAllSearch();
			}
		});

		document.addEventListener('click', (e) => {
			const anyOpen = instances.some(({ body }) =>
				body.classList.contains(activeClass)
			);

			if (!anyOpen) return;

			const insideSearch = instances.some(({ body, trigger }) =>
				body.contains(e.target) || trigger.contains(e.target)
			);

			if (!insideSearch) {
				closeAllSearch();
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
